import type { ReactNode } from "react";

import { FilterSearch } from "./DecisionRows";

export interface ManagementToolbarProps {
  search: string;
  onSearch: (value: string) => void;
  onSearchEnter?: () => void;
  searchLabel: string;
  filters?: ReactNode;
  action?: ReactNode;
}

/**
 * Barra do topo do Gerenciamento: busca, filtros e ação principal. Sem estado
 * nem textos próprios (tudo chega por props), para que SSCUI e App Fiori
 * possam adotá-la depois. Quem passa a ação decide o alinhamento (ex.: ml-auto).
 */
export function ManagementToolbar({ search, onSearch, onSearchEnter, searchLabel, filters, action }: ManagementToolbarProps) {
  return (
    <div data-testid="management-toolbar" className="rounded-lg border border-[var(--exed-card-border)] bg-[var(--exed-card-bg)]">
      <div role="search" aria-label={searchLabel} className="flex flex-wrap items-center gap-2 px-4 py-3">
        <FilterSearch value={search} onChange={onSearch} label={searchLabel} onEnter={onSearchEnter} />
        {filters}
        {action}
      </div>
    </div>
  );
}
